import React, { createContext, useContext, useState, useCallback, useMemo, ReactNode } from 'react';

type TConfig = {
  showProgress: boolean,
  showLogout: boolean,
  forceModule:boolean,
  session: string,
  key: string,
  sideVisible:boolean,
  sideCollapsed:boolean,
  isMobile: boolean,
  showConfigDrawer: boolean,
  module: string
  content:React.FC
  token: string
}
const initialState:TConfig = {
  showProgress: true,
  showLogout: false,
  forceModule:false,
  session: '',
  key: '',
  sideVisible:true,
  sideCollapsed:false,
  isMobile: false,
  showConfigDrawer: false,
  module: '',
  content:()=><></>,
  token: ''
}

interface ConfigContextType {
  config: TConfig;
  updateConfig: (newConfig: Partial<TConfig>) => void;
}
interface ConfigProviderProps {
  children: ReactNode;
}
const ConfigContext = createContext<ConfigContextType>({config:initialState,updateConfig:()=>{}});

export const ConfigProvider:React.FC<ConfigProviderProps> = ({ children }) => {
  const [config, setConfig] = useState(initialState);
  const updateConfig = useCallback((newConfig:Partial<TConfig>) => {
    setConfig((prevConfig) => ({ ...prevConfig, ...newConfig }));
  }, []);

  const contextValue = useMemo(() => ({
    config,
    updateConfig,
  }), [config, updateConfig]);

  return (
    <ConfigContext.Provider value={contextValue}>
      {children}
    </ConfigContext.Provider>
  );
};

export const useConfig = () => {
  return useContext(ConfigContext);
};